import type { MailRibbonConfigStore, TabNameType } from '../types/mailRibbonConfigStore';
import type { TabScalingAndLayoutConfig } from '../types/tabScalingAndLayoutConfig';

export type PartialRibbonConfiguration = {
    [lineKey in 'multiline' | 'singleline']: {
        [key in TabNameType]?: {
            layout?: TabScalingAndLayoutConfig['layout'];
            controlsInOverflow?: TabScalingAndLayoutConfig['controlsInOverflow'];
            showLabelsPreference?: TabScalingAndLayoutConfig['showLabelsPreference'];
            staticGroupIdOrdering?: TabScalingAndLayoutConfig['staticGroupIdOrdering'];
        };
    };
};

export function combineConfigStores(
    oldConfigStore: MailRibbonConfigStore,
    newConfigStore: PartialRibbonConfiguration
): MailRibbonConfigStore {
    const mergedStore: MailRibbonConfigStore = {
        ...oldConfigStore,
        multiline: { ...oldConfigStore.multiline },
        singleline: { ...oldConfigStore.singleline },
    };

    for (const multilineKey of Object.keys(newConfigStore.multiline)) {
        const multilineTab = multilineKey as TabNameType;
        mergedStore.multiline[multilineTab] = {
            ...oldConfigStore.multiline[multilineTab],
            ...newConfigStore.multiline[multilineTab],
        };
    }

    for (const singlelineKey of Object.keys(newConfigStore.singleline)) {
        const singlelineTab = singlelineKey as TabNameType;
        mergedStore.singleline[singlelineTab] = {
            ...oldConfigStore.singleline[singlelineTab],
            ...newConfigStore.singleline[singlelineTab],
        };
    }

    return mergedStore;
}
